import * as React from 'react';
import * as styled from './styled';
import {Droppable} from 'react-beautiful-dnd';
import {Word} from '../Word';
import {GroupProps, GroupVariant} from './types';

/**
 * The group of words.
 * @param {GroupProps} props
 * @return {React.ReactElement<GroupProps>}
 * @constructor
 */
function Group(
    props: GroupProps,
): React.ReactElement<GroupProps> {
  /**
   * Render title.
   * @return {JSX.Element}
   */
  function renderTitle(): JSX.Element {
    return (
      <styled.Title>
        {props.title}
      </styled.Title>
    );
  }

  /**
   * Render words.
   * @return {JSX.Element}
   */
  function renderWords(): JSX.Element {
    return (
      <styled.Words>
        {props.words.map((word, index) => (
          <Word key={index} index={index}>
            {word}
          </Word>
        ))}
      </styled.Words>
    );
  }

  return (
    <Droppable droppableId={props.title}>
      {(provided) => (
        <styled.Wrapper
          ref={provided.innerRef}
          variant={props.variant}
          {...provided.droppableProps}
        >
          {renderTitle()}
          {renderWords()}
          {provided.placeholder}
        </styled.Wrapper>
      )}
    </Droppable>
  );
}

Group.defaultProps = {
  variant: GroupVariant.Default,
}

export default Group;
